import type { ReactNode } from 'react';
import { Button } from '../../../components/ui/button';
import type { AdminAssignmentLabels } from '../../../hooks/useAdminAssignmentLabels';
import type { PlatformRoleAssignmentItemLocal } from '../../../api/types/PlatformLocal';

interface Props {
    items: PlatformRoleAssignmentItemLocal[];
    isPending: boolean;
    isError: boolean;
    onRetry: () => void;
    labels: AdminAssignmentLabels;
    renderAction?: (assignment: PlatformRoleAssignmentItemLocal) => ReactNode;
}

/** Roles asignados a un administrador, con su alcance por nombre; cubre carga, error y vacío. */
export function AdminAssignmentsList({
    items,
    isPending,
    isError,
    onRetry,
    labels,
    renderAction,
}: Props) {
    if (isPending) return <p className="text-sm text-muted-foreground">Cargando…</p>;
    if (isError) {
        return (
            <div className="flex flex-wrap items-center gap-2 text-sm">
                <span className="text-destructive">No pudimos cargar los roles asignados.</span>
                <Button variant="outline" size="sm" onClick={onRetry}>
                    Reintentar
                </Button>
            </div>
        );
    }
    if (items.length === 0) {
        return <p className="text-sm text-muted-foreground">Sin roles asignados</p>;
    }
    return (
        <ul className="space-y-1">
            {items.map((a) => (
                <li
                    key={a.assignmentId}
                    className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-input px-3 py-2 text-sm"
                >
                    <span className="flex flex-wrap items-center gap-2">
                        <span className="inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-foreground">
                            {labels.roleName(a.roleId)}
                        </span>
                        <span className="text-muted-foreground">
                            {labels.scopeName(a.scopeRef)}
                        </span>
                    </span>
                    {renderAction?.(a)}
                </li>
            ))}
        </ul>
    );
}
